import { __assign } from "tslib";
// tslint:disable-next-line:max-line-length
import { createCallcenterSettingsApi } from './index';
// tslint:disable-next-line:max-line-length
import { createFakeGetResponder, createFakePostResponder, createFakeDeleteResponder, createFakePutResponder } from '../../test-utils';
import { createHttpTestKit } from '../../http/test-kit';
export var createCallcenterSettingsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createCallcenterSettingsApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetGlobalCallOptions: function () {
            return createFakeGetResponder(fakeHttp, '/callcenter/queues/callOptions');
        },
        whenSetGlobalCallOptions: function (dto) {
            // tslint:disable-next-line:max-line-length
            return createFakePutResponder(fakeHttp, "/callcenter/queues/callOptions")(dto);
        },
        whenGetCustomBusyStatuses: function () {
            return createFakeGetResponder(fakeHttp, '/callcenter/customBusyStatuses');
        },
        whenAddCustomBusyStatus: function (name) {
            return createFakePostResponder(fakeHttp, "/callcenter/customBusyStatuses")({ name: name });
        },
        whenUpdateCustomBusyStatus: function (dto) {
            // tslint:disable-next-line:max-line-length
            return createFakePutResponder(fakeHttp, "/customBusyStatuses/" + dto.id)({ name: dto.name });
        },
        whenDeleteCustomBusyStatus: function (id) {
            return createFakeDeleteResponder(fakeHttp, "/callcenter/customBusyStatuses/" + id);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map